import { RootState } from "src/features/marketing/imports";

export const marketingSelectors = {
  getVisitData: (state: RootState) => state.marketing.visitData,
  getUserHashedInfo: (state: RootState) => state.marketing.userHashedInfo,
  getAnalyticsKey: (state: RootState) => state.marketing.analyticsKey,
};
